import clsApiPost from '@cls/clsApiPost'

class clsHourListApi extends clsApiPost {

    async copyLinesFrom(id_hourlist, year, week) {         
        return await this.post(`copylines`, {id_hourlist: id_hourlist, year: year, week: week});  
    }
}

export default clsHourListApi;
